import { render, staticRenderFns } from "./ScoreCaption.vue?vue&type=template&id=7e464f40&scoped=true"
import script from "./ScoreCaption.vue?vue&type=script&lang=js"
export * from "./ScoreCaption.vue?vue&type=script&lang=js"
import style0 from "./ScoreCaption.vue?vue&type=style&index=0&id=7e464f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e464f40",
  null
  
)

export default component.exports